import { render, staticRenderFns } from "./DocumentItemsProfitCard.vue?vue&type=template&id=45a77646&scoped=true"
import script from "./DocumentItemsProfitCard.vue?vue&type=script&lang=js"
export * from "./DocumentItemsProfitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a77646",
  null
  
)

export default component.exports